<script setup lang="ts">
// One option row for RegulatorPicker, shared by its single- and multi-select modes so the markup
// isn't duplicated per branch: regulator icon, acronym, full name, and an "em breve" hint when
// the option is disabled (a regulator with no codes yet).
import BaseIcon from '@/components/base/BaseIcon.vue';
import { regulatorIcon } from '@/constants/regulatorIcons';

defineProps<{ option: { slug: string; name: string; disabled?: boolean } }>();
</script>

<template>
  <div class="flex items-center gap-2">
    <BaseIcon size="sm" class="text-slate-500">{{ regulatorIcon(option.slug) }}</BaseIcon>
    <span class="text-sm font-semibold">{{ option.slug.toUpperCase() }}</span>
    <span class="text-xs text-slate-500">{{ option.name }}</span>
    <span v-if="option.disabled" class="ml-auto text-[11px] italic text-slate-400">em breve</span>
  </div>
</template>
